// extracted by mini-css-extract-plugin
export default {"issueTypePickerButton":"IssueTypePicker-module__issueTypePickerButton--akIKV","issueTypePickerLabel":"IssueTypePicker-module__issueTypePickerLabel--Y3noB"};